import { render, staticRenderFns } from "./navtar.vue?vue&type=template&id=3ade351d&"
import script from "./navtar.vue?vue&type=script&lang=js&"
export * from "./navtar.vue?vue&type=script&lang=js&"
import style0 from "./navtar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports